import { i18n } from '../i18n'

// RFC 5545 PRIORITY: 0 = undefined, 1 = highest ... 9 = lowest. Clients bucket it into
// high (1-4) / medium (5) / low (6-9); we write the bucket's canonical value.
export type PriorityLevel = 'none' | 'high' | 'medium' | 'low'

export const PRIORITY_VALUES: Record<PriorityLevel, number> = {
  none: 0,
  high: 1,
  medium: 5,
  low: 9,
}

export function priorityLabel(level: PriorityLevel): string {
  return i18n.global.t(`priority.${level}`)
}

export function priorityLevel(priority: number): PriorityLevel {
  if (!priority) return 'none'
  if (priority < 5) return 'high'
  if (priority === 5) return 'medium'
  return 'low'
}

// Sort rank: high first, none last.
export function priorityRank(priority: number): number {
  return priority ? priority : 10
}

export function priorityMarker(priority: number): string {
  return { none: '', high: '!!!', medium: '!!', low: '!' }[priorityLevel(priority)]
}
